/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Overview_Price1Inputs */

const id_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga`)
};

const ms_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga`)
};

const da_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pris`)
};

const de_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis`)
};

const en_us2_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

const es_es2_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio`)
};

const es_mx2_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio`)
};

const fil_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presyo`)
};

const fr_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix`)
};

const it_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzo`)
};

const hu_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ár`)
};

const nl_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijs`)
};

const no_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pris`)
};

const pl_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena`)
};

const pt_br2_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preço`)
};

const pt_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preço`)
};

const ro_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preț`)
};

const fi_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinta`)
};

const sv_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pris`)
};

const vi_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá`)
};

const tr_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiyat`)
};

const cs_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena`)
};

const bg_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цена`)
};

const ru_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цена`)
};

const uk_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ціна`)
};

const ar_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السعر`)
};

const hi_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कीमत`)
};

const th_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ราคา`)
};

const ja_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価格`)
};

const zh_cn2_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格`)
};

const zh_hant1_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`價格`)
};

const ko_offerdetail_overview_price1 = /** @type {(inputs: Offerdetail_Overview_Price1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가격`)
};

/**
* | output |
* | --- |
* | "Price" |
*
* @param {Offerdetail_Overview_Price1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_overview_price1 = /** @type {((inputs?: Offerdetail_Overview_Price1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Overview_Price1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_overview_price1(inputs)
	if (locale === "ms") return ms_offerdetail_overview_price1(inputs)
	if (locale === "da") return da_offerdetail_overview_price1(inputs)
	if (locale === "de") return de_offerdetail_overview_price1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_overview_price1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_overview_price1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_overview_price1(inputs)
	if (locale === "fil") return fil_offerdetail_overview_price1(inputs)
	if (locale === "fr") return fr_offerdetail_overview_price1(inputs)
	if (locale === "it") return it_offerdetail_overview_price1(inputs)
	if (locale === "hu") return hu_offerdetail_overview_price1(inputs)
	if (locale === "nl") return nl_offerdetail_overview_price1(inputs)
	if (locale === "no") return no_offerdetail_overview_price1(inputs)
	if (locale === "pl") return pl_offerdetail_overview_price1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_overview_price1(inputs)
	if (locale === "pt") return pt_offerdetail_overview_price1(inputs)
	if (locale === "ro") return ro_offerdetail_overview_price1(inputs)
	if (locale === "fi") return fi_offerdetail_overview_price1(inputs)
	if (locale === "sv") return sv_offerdetail_overview_price1(inputs)
	if (locale === "vi") return vi_offerdetail_overview_price1(inputs)
	if (locale === "tr") return tr_offerdetail_overview_price1(inputs)
	if (locale === "cs") return cs_offerdetail_overview_price1(inputs)
	if (locale === "bg") return bg_offerdetail_overview_price1(inputs)
	if (locale === "ru") return ru_offerdetail_overview_price1(inputs)
	if (locale === "uk") return uk_offerdetail_overview_price1(inputs)
	if (locale === "ar") return ar_offerdetail_overview_price1(inputs)
	if (locale === "hi") return hi_offerdetail_overview_price1(inputs)
	if (locale === "th") return th_offerdetail_overview_price1(inputs)
	if (locale === "ja") return ja_offerdetail_overview_price1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_overview_price1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_overview_price1(inputs)
	return ko_offerdetail_overview_price1(inputs)
});
export { offerdetail_overview_price1 as "offerDetail.overview.price" }